var default_styles_default = {
  "button_container": "r-GpN",
  "button_margin": "_-4-Up",
  "button_text": "tRCPp",
  "button_size_content": "JlG-I"
};
export {
  default_styles_default as default
};
//# sourceMappingURL=default-styles-scss.js.map
